export default "__VITE_ASSET__B6bgrgE6__"